import api from "./api";

const medicalServices = {};
const endpoint = "/medical-services";

medicalServices.get = function (query = {}) {
  return api.get(endpoint, { params: query }).then((res) => res.data);
};

medicalServices.getPaginated = function (page = 1, limit = 20, query = {}) {
  return api
    .get(endpoint, {
      params: {
        page,
        limit,
        ...query,
      },
    })
    .then((res) => res.data);
};

medicalServices.createMedicalServices = function (medicalServices) {
  return api.post(endpoint, medicalServices).then((res) => res.data);
};

export default medicalServices;
